export const AUTHENTICATION_TAGS = {
  AUTHENTICATION_TAG: "Authentication",
};
